import {Tab} from "bootstrap";

document.addEventListener("DOMContentLoaded", function() {
  // Check if there's a hash in the URL
  const hash = window.location.hash;
  if (hash) {
    const tabLink = document.querySelector('a[href="' + hash + '"]');
    if (tabLink) {
      const tabInstance = Tab.getOrCreateInstance(tabLink);
      tabInstance.show();
    } else {
      console.error("No tab found for hash:", hash);
    }
  }
  const tabLinks = document.querySelectorAll('a.login__header_link[data-bs-toggle="tab"]');
  if (tabLinks.length) {
    tabLinks.forEach(tabLink => {
      tabLink.addEventListener('shown.bs.tab', function(event) {
        const newHash = event.target.getAttribute('href');
        history.replaceState(null, null, newHash);
      });
    });
  }
});
